<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-8 col-md-10 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Message Reports</h3>
                    </div>
                    <div class="col-4 col-md-2">
                      <button v-if="!contact_form" @click="showSMSForm" class="btn btn-primary text-white simple-btn">Send SMS</button>
                      <button v-if="contact_form" @click="showSMSForm" class="btn btn-danger text-white simple-btn">Close SMS</button>  
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row">
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    
                    <div class="col-sm-4 col-md-1 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterMessages(1)" class="btn btn-success simple-btn">Filter</button>
                    </div>

                    <div class="col-sm-12 col-md-4 col-12 stretch-card col-grid"></div>
                   
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                        <input type="text" v-model="search_field" class="date_input form-control"/>             
                    </div>
                    <div class="col-sm-4 col-md-1 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterMessages(2)" class="btn btn-primary simple-btn">Search</button>
                    </div>
                </div>

                <div v-if="contact_form">
                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-7 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Phone numbers (comma separated)</label>
                                        <textarea class="form-control" rows="5" v-model="this.phone_list"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Message</label>
                                        <textarea class="form-control" v-model="this.message"></textarea>
                                    </div>
                                   
                                    <div class="d-flex justify-content-between">
                                        <button class="btn btn-primary" @click="sendSms()">Send SMS</button>
                                        <button class="btn btn-danger text-white" @click="clearPhoneList">Clear Chat</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        <div v-if="user.role > 1">   
    <div class="mt-3"></div>
    <h5>Messaging Summary</h5>
    <div class="row">
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
            <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                    <p>Last 7Days</p>
                    <p class="fs-25"><PriceFormat :Price="sms_data.day7"/></p>
                   
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
            <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                     <p>Last 30Day</p>
                    <p class="fs-25"><PriceFormat :Price="sms_data.day30"/></p>
                  
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
            <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                     <p>Life Time</p>
                    <p class="fs-25"><PriceFormat :Price="sms_data.sms_lifetime"/></p>
                  
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
           <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                    <p>SMS Balance</p>
                    <p class="fs-25"><PriceFormat :Price="sms_data.sms_balance"/></p>
                   
                </div>
            </div>
        </div>
    </div>
    </div>

                 <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                            <th>Message</th>
                            <th>Destination's</th>
                            <th>SMS'S</th>
                            <!--th>Created by</th-->
                            <th>Created At</th>
                            <th></th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(message, index) in paginatedMessages" :key="message.id" :id="'message_'+message.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                <td>{{ truncate(message.message)}}</td><!--substr 30-->
                                    <td v-if="message.batch_id == 0" class="text-warning">
                                        <p class="text-sm">Phone List ({{message.destinations}})</p>
                                    </td>
                                    <td v-if="message.batch_id == 1" class="text-success">
                                        <p class="text-sm">All Customers ({{message.destinations}})</p>
                                    </td>
                                    <td v-if="message.batch_id > 1" class="text-primary">
                                        <p class="text-sm">{{ truncate(message.name, 12)}} ({{message.destinations}})</p><!--substr 10-->
                                    </td>
                                    
                            <td><span class="badge badge-primary">{{message.messages}}</span></td>
                            <!--td>{{substr 10 message.fulname}}</td-->
                            <td><DateFormat :Date_="message.created_at"/></td>
                            <td>
                                <button class="btn btn-success text-white p-1" @click="this.getViewMessage(message)">
                                            <i class="fa fa-eye"></i> view
                            </button>

                            </td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div v-if="this.messages.length > 0" class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
            </div>
        </div>
    </div>

 <!-- Modal -->
<div class="modal fade auto-off hide" data-bs-backdrop="static" data-bs-keyboard="false" id="demoModal" tabindex="-1"
    role="dialog" aria-labelledby="demoModal" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">

            <div class="">
                <div class="card mt-3">
                    <div class="card-header px-3">
                        <div class="row">
                            <div class="col-md-6">
                                <h6 class="mb-0">Message Details</h6>
                            </div>

                        </div>
                    </div>
                    <div class="card-body">
                        <p for="" class="text-uppercase text-secondary text-xs font-weight-bolder p-label">Message</p>
                        <p id="dmessage">
                            {{ message_details.message }}
                        </p>
                        <p for="" class="text-uppercase text-secondary text-xs font-weight-bolder p-label">Phone List
                        </p>
                        
                        <p class="text-xs" id="dphones">
{{ message_details.phone_list }}
                        </p>
                        <div class="d-flex justify-content-between">
                            <p id="ddestination" class="text-primary"> <span class="p-label">Destinations : </span> <span class="strong">{{ message_details.destinations }}</span></p>
                            <p id="dsms" class="text-primary"><span class="p-label"> Messages :</span> <span class="strong">{{ message_details.messages }}</span></p>
                        </div>
                        <div class="d-flex justify-content-between mt-2">
                            <p class="text-capitalize" id="dfulname">{{ message_details.fulname }}</p>
                            <button type="button" data-bs-dismiss="modal" class="btn btn-primary my-sm-btn">
                                Close
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_sms_details:false,
            contact_form:false,
            errors: "",
            phone_list:"",
            message:"",
            fdate:"",
            tdate:"",
            filter_branch: "",
            messages:[],
            message_details:{},
            message_phone_list:"",
            og_messages:[],
           sms_data:{},
            parcel: {},
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

        async filterMessages(type){

             this.loading = true

          var _search =  this.search_field
          var sdate = this.fdate
          var edate = this.tdate

          if(type == 1){

            _search = ""

            if (sdate == null || sdate == '' || edate == null || edate == '') {
            alert('Start and End Date are Required')
            return false;
        } else {
            if (sdate > edate) {
                alert('Start date must not be greater than End Date')
                return false;
            } 
        }

          }

          if(type == 2){
            if(_search == null || _search == undefined || _search == ""){
                alert("Andika chochote kwenye search box")
                return false
            }
          }

          var response = await axios
              .post(this.$store.state.api_url + "/filter-messages", {_search, sdate, edate})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.messages = response.data.messages;
                this.og_messages = response.data.messages
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        async getViewMessage(message) {

            this.message_details = message

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("demoModal")
            );

            modal.show();

        },
        showSMSForm(){
            this.contact_form = !this.contact_form
        },

        async getMessages() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/message-report")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                  this.loading = false
                this.messages = response.data.messages;
                 this.sms_data = response.data.sms_data;
               
                this.og_messages = response.data.messages

               /// console.log(this.messages)

            } else {
                  this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

 addPhoneList(phone) {

    this.contact_form = true
        // Convert string to array and remove empty values
        let phones = this.phone_list
            ? this.phone_list.split(",").map(p => p.trim()).filter(Boolean)
            : [];

        // Check if phone already exists
        const index = phones.indexOf(phone);

        if (index !== -1) {
            if (confirm(`${phone} already exists.\n\nDo you want to remove it?`)) {
                phones.splice(index, 1);
            } else {
                return;
            }
        } else {
            phones.push(phone);
        }

        // Convert back to comma-separated string
        this.phone_list = phones.join(",");
    },
    clearPhoneList(){
        this.phone_list = ""
    },
  async sendSms (){

    this.loading = true

          var phone_list = this.phone_list
          var message = this.message

          var response = await axios
              .post(this.$store.state.api_url + "/send-multi-sms", {phone_list, message})
              .catch((errors) => {
                    this.loading = false
                  var message_ = "Network or Server Errors";
                  this.$toast.error(message_, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {
               this.loading = false
             
              var message_ = response.data.message;
              this.$toast.success(message_, { duration: 5000, dismissible: true });

              this.phone_list = ""
              this.message = ""

          } else {
            
                this.loading = false
              var message_ = response.data.message;
              this.$toast.error(message_, { duration: 5000, dismissible: true });
          }
    },
    truncate(text, length = 30) {

        if (!text) return "";

        return text.length > length
            ? text.substring(0, length) + ".."
            : text;

    }

    },
      computed: {

  paginatedMessages() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.messages.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.messages.length / this.perPage)
  },
  

},
    watch: {

     
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getMessages()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
